import * as React from 'react';
import styles from '../Tour.module.scss';

const STEP1 = {
  target: '[data-tour="header__link_logo"]',
  content: <p>Ведет на официальный сайт ФНС России - nalog.ru</p>,
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP2 = {
  target: '[data-tour="header__link_home"]',
  content: <p>Ведет на главную страницу личного кабинета налогоплательщика</p>,
  hideCloseButton: true,
  disableBeacon: true,
};

const STEP3 = {
  target: '[data-tour="header__profile"]',
  content: (
    <div>
      <p>Ведет на страницу профиля, где можно:</p>
      <ul className={styles.listContainer}>
        <li>изменить свои контактные данные;</li>
        <li>подобрать налоговые услуги;</li>
        <li>продолжить прохождение обучающего тура;</li>
        <li>получить электронную подпись</li>
      </ul>
    </div>
  ),
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP4 = {
  target: '[data-tour="header__wallet"]',
  content: (
    <p>
      Ведет на страницу единого налогового платежа, позволяющего внести средства для исполнения
      обязанности по уплате транспортного налога, земельного налога и (или) налога на имущество,
      которые будут списаны своевременно автоматически
    </p>
  ),
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP5 = {
  target: '[data-tour="header__other-features"]',
  content: <p>Поиск по сайту и другие дополнительные возможности</p>,
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP6 = {
  target: '.menu.menu__main > [data-tour="mainmenu__taxes"]',
  content: (
    <p>
      Ведет в раздел с подробной информацией о доходах, переплатах, начисленных и оплаченных налогах
    </p>
  ),
  hideCloseButton: true,
  disableBeacon: true,
};

const STEPS_MAIN = [STEP1, STEP2, STEP3, STEP4, STEP5, STEP6];
export default STEPS_MAIN;
